<template>
<modal name="eprint-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top">
    <el-button @click="closeDialog"
      icon="el-icon-close"
      type="text"></el-button>
  </div>
  <div class="setting">
    <div class="setting-item" v-if="eprintResultCode == '100'" style="padding:0;margin:0;">
      <h1>コンビニ印刷とは？</h1>
      <p>作成した履歴書をコンビニで印刷できます。</p>
      <div class="text-right">
          <a href="https://www.e-printservice.net/shohin/yagish"
             id="footer-link-eprint"
             class="external-link"
             target="_blank"
             rel="nofollow">詳しい利用方法を確認する</a>
      </div>
      <h1>利用料金</h1>
      <div v-if="isNotLetter">
        <p>
        <el-radio 
                  v-model="printType"
                  label="9">白黒片面(B4) ：2枚/300円(税込)</el-radio>
        </p>
        <img  src="/static/img/eprint/b4mono_one.png" style="margin-left: 50px;width: 150px;" alt="">

        <p>
        <el-radio 
                  v-model="printType"
                  label="11">白黒片面(A4) ：8枚/300円(税込)</el-radio>
        </p>
        <img  src="/static/img/eprint/a4mono_one.png" style="margin-left: 50px;width: 150px;" alt="">

        <p>
        <el-radio 
                  v-model="printType"
                  label="3">白黒両面(A4) ：4枚/300円(税込)</el-radio>
        </p>
        <img  src="/static/img/eprint/a4mono_two.png" style="margin-left: 50px;width: 150px;" alt="">

        <p>
        <el-radio 
                  v-model="printType"
                  label="5">白黒両面(A3) ：2枚/300円(税込)</el-radio>
        </p>
        <img  src="/static/img/eprint/a3mono_two.png" style="margin-left: 50px;width: 150px;" alt="">
      </div>
      <div v-else>
        <p>
        <el-radio 
                  v-model="printType"
                  label="14">白黒片面(B4) ：2枚/300円(税込)</el-radio>
        </p>
        <img  src="/static/img/eprint/b4mono_one.png" style="margin-left: 50px;width: 150px;" alt="">

        <p>
        <el-radio 
                  v-model="printType"
                  label="13">白黒片面(A4) ：2枚/300円(税込)</el-radio>
        </p>
        <img  src="/static/img/eprint/a4mono_one.png" style="margin-left: 50px;width: 150px;" alt="">

        <p>
        <el-radio 
                  v-model="printType"
                  label="15">白黒片面(A3) ：1枚/300円(税込)</el-radio>
        </p>
        <img  src="/static/img/eprint/a3mono_one.png" style="margin-left: 50px;width: 150px;" alt="">
      </div>
      <p class="text-right">※お支払いはコンビニでお願いします。</p>
      <h1>利用規約</h1>
      <div class="page-static-inner" style="height:200px;overflow:auto;border:1px solid #aaa;padding:5px;">
        <h2>第1条（規約の適用）</h2>
        <p>「【e プリントサービス】ご利用規約」(以下、「本規約」といいます)は、株式会社ビジネス・インフォメーション・テクノロジー(以下、 「当社」といいます。)が提供する本サービス(第 2 条で定義されます。)の利用者(以下、「サービス利用者」といいます)が本サー ビスを利用するにあたり行う一切の行為に適用されるものとし、サービス利用者は本規約に同意の上、本サービスを利用するも のとします。</p>
        <h2>第2条（サービスの定義）</h2>
        <p>本サービスは、サービス利用者が「yagish(ヤギッシュ)」ウェブサイト内にて入力した登録内容を対象のコピー機を利用して出力するサービスである。</p>
        <h2>第3条（サービスの利用）</h2>
        <p>本サービスをご利用になる場合、サービス利用者は、本規約に同意する必要があります。</p>
        <ol>
          <ul>
            <li>画面に表示される画像と印刷出力されたものは、異なる場合があります。</li>
            <li>印刷物について、印刷上の瑕疵がある場合を除き、交換・返金することはできません。</li>
          </ul>
        </ol>
        <h2>第4条（サービスの中断・中止等）</h2>
        <p>本サービスの中断、中止、停止、廃止、変更によりサービス利用者に生じた損害について、当社は一切の責任を負いません。</p>
        <h2>第5条（サービス利用者の責務）</h2>
        <p>サービス利用者は本サービスを介して、使用したデータファイルに関する一切の責任を負うものとします。本サービスを介してデ ータファイルを利用する際は、内容の信頼性、正確性、完成度、有用性、ウイルスの有無などについて各自で判断し、サービス利 用者の責任とリスク負担のもとで利用するものとします。 また、本サービスを介して、以下の行為を行うことを禁止いたします。</p>
        <ul>
          <li>他のサービス利用者または第三者の知的財産権の侵害</li>
          <li>他のサービス利用者または第三者への誹謗、中傷</li>
          <li>他のサービス利用者または第三者に不利益を与える行為</li>
          <li>公序良俗に反する行為</li>
          <li>法令に違反する行為、また、違反のおそれのある行為</li>
          <li>本サービスまたは本サービスを提供する機器もしくはネットワークを妨害したり、混乱させたりする行為</li>
          <li>大量及び大容量のファイルを不特定多数に配布し、当社が提供するインフラ、システム等に多大なる負荷をかける行為</li>
        </ul>
        <h2>第6条（作成したファイルの取り扱い）</h2>
        <ol>
          <li>当社は、本サービスで利用したデータファイル(以下、「本件利用ファイル」といいます。)に関する一切の責任を負いません。</li>
          <li>本サービスから本件利用ファイルのバックアップはサービス利用者自らが行うものとし、本サービスに一時保存されていたデータ が消滅した場合においても、当社はいかなる責任も負いません。</li>
          <li>サービス利用者は、本サービスから本件利用ファイルについて、当社の関知しない種々のネットワークや機器を経由することがあることを理解し、場合によっては、本件利用ファイルの内容に異常をきたす可能性があること、意図しない第三者による盗み見、 利用等が行われる可能性がゼロではないことを理解したうえで本サービスを利用するものとします。</li>
        </ol>
        <h2>第7条（本人特定情報の非公開）</h2>
        <p>当社は、サービス利用者の個人を特定できる項目の情報(氏名、住所、電話番号、メールアドレスの情報がこれに該当するものと し、以下、「本人特定情報」といいます)をサービス利用者の承諾なしに第三者へ公開しないものとします。ただし、下記に該当す る場合にはこの限りではありません。</p>
        <ul>
          <li>国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要があり、サービス利用者自身の同意を得ることによりその事務の遂行に支障を及ぼす恐れがある場合</li>
          <li>サービス利用者自身から明示的に第三者への開示又は提供を求められた場合</li>
          <li>その他サービス利用者自身へサービスを提供するために必要であると当社が判断した場合</li>
        </ul>
        <h2>第8条（会員登録情報の削除）</h2>
        <p>当社は、以下の事由がある場合には、サービス利用者に対し事前に通知することなくサービス利用者登録情報の削除を行うこと があります。この場合、当社がサービス利用者登録情報を削除し、本サービスの利用ができなくなった場合でも、当社は、サービ ス利用者に対して一切責任を負わないものとします。</p>
        <ul>
          <li>本規約に違反した場合</li>
          <li>その他、本サービスを利用するのにふさわしくないと当社が判断した場合</li>
        </ul>
        <h2>第9条（サービスに関する無保証）</h2>
        <p>当社は、本サービスの内容、提供の状態、アクセスの可能性、使用の状態について一切の保証をいたしません。問い合わせへ の回答など、会員が当社から直接または本サービスを通じて得た情報やアドバイスについても、サービス利用者から伝えられた 限られた情報に基づいて行われており、その内容の真偽、適格性、正確性について保証するものではありません。</p>
        <h2>第10条（免責事項）</h2>
        <p>当社は、サービス利用者が本サービスを利用したこと、または本サービスを利用できなかったことによって、サービス利用者また は第三者に生じた一切の損害について責任を負わないものとします。 これには、直接的、間接的、偶発的、例外的、及び結果的 な懲罰的損害(利益、友好関係、効用、データの滅失・毀損・劣化・盗聴・漏洩その他の無形損失を含むがこれに限定されるものではない)などの一切の損害が含まれます。このことは、損害の可能性に関する忠告が事前にあった場合にも適用されます。</p>
        <h2>第11条（知的財産権）</h2>
        <p>本サービス、及び本ウェブサイト上に掲載される個々の文章、図形、デザイン、商標、ロゴマーク等に関する著作権、商標権その 他の知的財産権は、当社に著作権が属しているか、もしくは、当社がその使用許諾を得て提供しているものです。サービス利用 者は、著作権、商標権その他の知的財産権を侵害しないことに同意します。</p>
        <h2>第12条（規約の変更）</h2>
        <p> 当社は予告なく本規約を変更できるものとします。また本規約が変更され、変更後の規約が本サービスの提供されているウェブ ページに掲載されたときから直ちに、変更後の内容が適用されます。</p>
        <h2>第13条（本サービスの内容の変更）</h2>
        <p>当社は、いつでも本サービスの内容を変更できるものとし、サービス利用者は予めこれを承諾するものとします。</p>
        <h2>第14条（準拠法、裁判管轄）</h2>
        <p> 本規約の準拠法は日本法とします。また、本サービスまたは本規約に関連して当社とサービス利用者の間で生じた紛争について は東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
        <h2>第15条（協議）</h2>
        <p>本規約に定めていない事項については、信義誠実の原則に従い、協議解決するものとします。</p>
        <p class="text-right">2019年11月8日制定</p>
      </div>
    </div>
    <div class="setting-item" v-if="eprintResultCode == '100'&$firebase.isAuthenticated">
      <div class="attention-logged-in">
            <el-button id="pdf-eprint-edit"
                       type="success"
                       class="button-block"
                       :disabled="!$deviceLib.isOnline"
                       v-loading.fullscreen.lock="!eprintPdfEnabled"
                       @click="$eventHub.$emit('eprint-PDF2');eprintPdfEnabled = false;closeDialog">
              <i class="el-icon-printer"></i> 利用規約に同意して印刷する
            </el-button>
      </div>
      <p style="color:red;">※OSが古い場合など、レイアウトが崩れる場合があります。<br>また、{{ paperNumb2 }}ページ目入ると、コンビニ印刷には対応しておりません。<br>プレビューで内容をご確認のうえ、ご購入ください。
      </p>
      <p>ご不明点等ございましたら、<a rel="nofollow"
           href="https://docs.google.com/forms/d/e/1FAIpQLSdQWd8nDWMjACUan0rTQH7zQA7kP9tK_YoU5GL2_CpbUpUIiw/viewform"
           target="_blank">こちらのフォーム</a>よりご連絡ください。</p>
    </div>
    <div class="setting-item" v-if="eprintResultCode != '100'">
      <h2>印刷の用意ができました。</h2>
      <p>下記の情報を控えた上、お近くのコンビニで決済・印刷を行ってください。</p>
      <p>yagishコンビニ印刷は</p>
      <h1>『eプリントサービス』</h1>
      <p>です。お間違えの無いようにお願いします。</p>
      <h1>コンテンツ番号：{{ eprintContentsCode }}</h1>
      <p style="color:red;">セブン-イレブンをご利用の場合は、10分程お待ちいただいてからお試しください。</p>
      <h3>有効期限：{{ expirationDate }}まで</h3>
      <div class="btn_wrapper">
        <a href="https://bit.ly/3vCdWF4" class="router-link-active">
        <a class="btn_sub" style="border-radius: 20px;color: #FFF;background-color: #0F9934;border-color: #0F9934;">新しく送付状を作成できるようになったよ！<br>送付状を入れると企業からの評価が上がるよ！</a>
        </a>
      </div>
      <h3>※利用時の注意事項</h3>
      <p>・有効期限が過ぎた場合やコンテンツ番号を忘れた場合は再度コンビニ印刷を行ってください。</p>
      <p>・ローソン・ファミリーマート以外のコンビニについては、10分程お時間がかかります。「販売終了もしくは、商品番号の入力が誤っている可能性があります。商品番号をご確認してください。」が表示された場合、少し時間を空けて再度ご入力をお試しください。</p>
      <div class="text-right">
          <a href="https://www.e-printservice.net/shohin/yagish"
             id="footer-link-eprint"
             class="external-link"
             target="_blank"
             rel="nofollow">詳しい利用方法を確認する</a>
      </div>
    </div>
  </div>
  <div class="text-right">
    <el-button @click="closeDialog">閉じる</el-button>
  </div>
</modal>

</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  data: function () {
    return {
      eprintPdfEnabled: true,
      isNotLetter: true,
      resultname: '',
      eprintResultCode: '100',
      eprintContentsCode: '',
      expirationDate: '',
      previewHtml: '',
      currentFormat: {},
      totalCost: 0,
      clearLocalStorageConfirmVisible: false,
      loading: true,
      formatid: '',
      paperInfo: '',
      paperNumb: '1',
      paperNumb2: '3',
      printType: '2',
      selFontStyle4DB: '',
      printTypeOptions: [
        {
          value: '2',
          label: '白黒両面(A4) ：1枚/300円(税込)'
        },
        {
          value: '4',
          label: '白黒片面(A3) ：1枚/300円(税込)'
        }
      ]
    }
  },
  methods: {
    openDialog: function (id, html, selFontStyle4DB) {
      // alert('システムメンテナンス中です。サービス再開までしばらくお待ちください。再開はお知らせにて掲載いたします。')
      // return
      this.formatid = id
      this.selFontStyle4DB = selFontStyle4DB
      this.previewHtml = html.$el.innerHTML
      this.paperInfo = '両面'
      this.paperNumb = '最大4'
      this.paperNumb2 = '9'
      this.printType = '3'
      this.$modal.show('eprint-dialog')
      this.clearLocalStorageConfirmVisible = false
      if (this.formatid == 'letter') {
        this.isNotLetter = false
        this.printType = '13'
      }
    },
    closeDialog: function () {
      this.$modal.hide('eprint-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    eprintPDF2: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      this.eprintPDFSending = true
      const formData = this.pdfFormData
      formData.append('filename', this.createFilename('pdf'))
      formData.append('format_id', this.formatid)
      formData.append('print_type', this.printType)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('font_name', this.selFontStyle4DB)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.pdfEprint, formData, { timeout : 60000 })
        .then(function (response) {
          if (response.data.result === 'success') {
            app.resultname = 'なし'
            app.eprintResultCode = '200'
            app.eprintContentsCode = response.data.contents_code
            app.expirationDate = response.data.expiration_date
          } else {
            if (response.data.message === '不正なページ数です') {
              app.$message({
                duration: 0,
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: `送信失敗しました。${response.data.message}<br><br>ふりがなが長すぎるなどの理由により、フォーマットが崩れている可能性があります。<br>入力内容を確認し、修正してください。<br>ブラウザのキャッシュを削除するか、更新してください。`,
                type: 'error'
              })
            } else if (response.data.message === 'バージョンエラーです。ブラウザのキャッシュを削除するか、更新してください。') {
              app.$message({
                duration: 0,
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: `送信失敗しました。${response.data.message}<br><br>今見ている画面が古い可能性があります。<br>ブラウザのキャッシュを削除するか、更新してください。`,
                type: 'error'
              })
            } else {
              app.$message({
                duration: 0,
                showClose: true,
                message: `送信失敗しました。${response.data.message}`,
                type: 'error'
              })
            }
          }
        })
        .catch(function (error) {
          app.$message({
            duration: 0,
            showClose: true,
            message: '送信失敗しました。しばらくしてから再度お試しください',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf eprint api', `send pdf eprint-api failed ${error}`)
        }).finally(function () {
          app.eprintPdfEnabled = true
          app.eprintPDFSending = false
        })
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      const LENGTH = 5
      const WORDS = 'abcdefghijklmnopqrstuvwxyz0123456789'
      var rString = ''
      for (var i = 0; i < LENGTH; i++) {
        rString += WORDS[Math.floor(Math.random() * WORDS.length)]
      }
      rString += '_'
      return `${prefix}${rString}${this.formatid}${dateString}.${ext}`
    },
    dataChanged: function () {
      this.eprintResultCode = '100'
      this.eprintPdfEnabled = true
      this.paperInfo = '片面'
      if (this.formatid === 'rirekisho_single' || this.formatid === 'rirekisho_nophoto') {
        this.paperInfo = '片面'
      } else {
        this.paperInfo = '両面'
      }
    }
  },
  computed: {
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.previewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('open-eprint-dialog', this.openDialog)
    this.$eventHub.$on('eprint-PDF2', this.eprintPDF2)
    this.$eventHub.$on('popstate', this.closeDialog)
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('open-eprint-dialog', this.openDialog)
    this.$eventHub.$off('eprint-PDF2', this.eprintPDF2)
    this.$eventHub.$off('popstate', this.closeDialog)
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
  }
}
</script>
